import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "@/components/Field";
import { SegmentedControl } from "@/components/ui/segmented-control";
import { Textarea } from "@/components/ui/textarea";
import { Markdown } from "@/lib/markdown";

/** Long text with an optional preview of the formatting (lists, bold, links). */
export function MarkdownField({
  label,
  hint,
  value,
  onChange,
  error,
  rows = 5,
  maxLength = 20000,
}: {
  label: string;
  hint?: string;
  value: string;
  onChange: (v: string) => void;
  error?: string | null;
  rows?: number;
  maxLength?: number;
}) {
  const { t } = useTranslation();
  const [mode, setMode] = useState<"write" | "preview">("write");
  return (
    <div className="flex flex-col gap-2">
      <Field label={label} hint={hint} error={error}>
        {(p) =>
          mode === "write" ? (
            <Textarea {...p} rows={rows} maxLength={maxLength} value={value} onChange={(e) => onChange(e.target.value)} />
          ) : (
            <div id={p.id} className="min-h-24 rounded-md border border-border bg-surface-muted px-4 py-3">
              {value.trim() ? <Markdown source={value} /> : <p className="text-fg-muted">{t("markdown.nothing")}</p>}
            </div>
          )
        }
      </Field>
      <SegmentedControl
        label={t("markdown.mode", { field: label })}
        value={mode}
        onChange={setMode}
        options={[
          { value: "write", label: t("markdown.write") },
          { value: "preview", label: t("markdown.preview") },
        ]}
      />
    </div>
  );
}
